import { render, staticRenderFns } from "./v-footer.vue?vue&type=template&id=a90bda0c&scoped=true"
import script from "./v-footer.vue?vue&type=script&lang=js"
export * from "./v-footer.vue?vue&type=script&lang=js"
import style0 from "./v-footer.vue?vue&type=style&index=0&id=a90bda0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a90bda0c",
  null
  
)

export default component.exports